"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsProvider = void 0;
const SERVICE_NOT_INITIALIZED_ERROR = 'AnalyticsService is not initialized';
class AnalyticsProvider {
    static getAnalytics() {
        if (!window.analyticsService) {
            throw new Error(SERVICE_NOT_INITIALIZED_ERROR);
        }
        return window.analyticsService;
    }
}
exports.AnalyticsProvider = AnalyticsProvider;
